import { CommonModule } from '@angular/common';
import { Component, input, OnInit, output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { LetModule, OtpInputComponent } from '@hglobal/common';
import { FormControl } from '@ngneat/reactive-forms';
import { TranslateModule } from '@ngx-translate/core';
import { map, Observable, of, share, take, tap, timer } from 'rxjs';

@Component({
  selector: 'pp-otp-form',
  imports: [CommonModule, FormsModule, OtpInputComponent, ReactiveFormsModule, TranslateModule, LetModule],
  templateUrl: './otp-form.component.html',
  styleUrl: './otp-form.component.scss',
})
export class OtpFormComponent implements OnInit {
  readonly control = input<FormControl<string>>();
  readonly title = input<string>();
  readonly sentTo = input<string>();
  readonly numberSize = input(6);
  readonly countdownInSec = input(90);
  readonly hasAutofocus = input(true);
  readonly localStorageKey = input<string>(null);

  readonly resend = output<void>();
  readonly countdownFinish = output<void>();

  countdown$: Observable<number>;

  ngOnInit() {
    const lastSentTimestamp = Number(localStorage.getItem(this.localStorageKey()));
    const now = Date.now();
    const isTimestampValid = lastSentTimestamp !== 0;
    const elapsedSeconds = isTimestampValid ? Math.floor((now - lastSentTimestamp) / 1000) : null;

    if (!isTimestampValid) {
      localStorage.setItem(this.localStorageKey(), now.toString());
      this.#startCountdown();
    } else if (elapsedSeconds >= this.countdownInSec()) {
      this.resendCode();
    } else {
      this.#startCountdown();
    }
  }

  resendCode(): void {
    localStorage.setItem(this.localStorageKey(), Date.now().toString());

    this.#startCountdown();
    this.resend.emit();
  }

  #startCountdown(): void {
    const lastSentTimestamp = Number(localStorage.getItem(this.localStorageKey()));
    const now = Date.now();
    const total = this.countdownInSec();
    const remaining = total - Math.floor((now - lastSentTimestamp) / 1000);

    if (remaining <= 0) {
      this.countdown$ = of(0);
      this.countdownFinish.emit();
      return;
    }

    this.countdown$ = timer(0, 1000).pipe(
      take(remaining),
      map(i => remaining - i - 1),
      tap(value => value === 0 && this.countdownFinish.emit()),
      share(),
    );
  }
}
